import { render, staticRenderFns } from "./KlausA3.vue?vue&type=template&id=5bf894be&"
import script from "./KlausA3.vue?vue&type=script&lang=js&"
export * from "./KlausA3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports